import React, { useState } from 'react';
import './TastFooter.module.scss';

export default function TastFooter() {
    const [activeGiff, setActiveGiff] = useState(
        '/images/studio-footer/idle.gif'
    );
    return (
        <>
            <a
                target="_blank"
                rel="noreferrer"
                href="https://www.studiotast.com/"
                styleName="tast-footer"
                onMouseOver={() => {
                    setActiveGiff('/images/studio-footer/hover.gif');
                }}
                onMouseLeave={() => {
                    setActiveGiff('/images/studio-footer/idle.gif');
                }}
                onFocus={() => {
                    setActiveGiff('/images/studio-footer/hover.gif');
                }}
            >
                <p>
                    With a<br /> touch of{' '}
                </p>
                <img alt="squigly diggly" src={`${activeGiff}`} />
            </a>
        </>
    );
}
